import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Field, FormSection } from 'redux-form';
import { i18n, isNumber, isRequired, maxWeight,
   maxWeightImperial, minWeight, minWeightImperial, validValue} from '../../../utils';
import TextInput from '../TextInput';

interface IProps {
  useImperialUnit: boolean;
  onSubmitEditing: () => void;
  t(key: string, options?: any): string;
}

export class WeightField extends React.Component<IProps> {
  private weightInput;
  public render() {
    const { textInputStyle, useImperialUnit, isInlineValidation,
      isImperialContainerWidth, showLabel, hasPlaceholder = true, autoFocus = false} = this.props;
    const {minMaxChecks, weightPlaceholder} = this.getPropertiesBasedOnUnitPref(useImperialUnit);
    const form = (
      <View style={[{width: '100%'}, isImperialContainerWidth && styles.imperialContainerWidth]}>
          <Field
            {...this.props}
            forwardRef
            name='weight'
            component={TextInput}
            autofocus={autoFocus}
            isInlineValidation={isInlineValidation}
            autoCapitalize='none'
            placeholder={ hasPlaceholder ? i18n.t('formFields:weightWithoutMetric') : ''}
            keyboardType='numeric'
            isRequired={true}
            showLabel={!!showLabel}
            returnKeyType='done'
            validate={[isRequired, isNumber,  ...minMaxChecks]}
            ref={(ref) => { this.weightInput = ref; }}
            textInputStyle={textInputStyle}
            unitSuffixText={i18n.t(`formFields:${weightPlaceholder}`)}
            placeHolderMargin={isImperialContainerWidth && styles.imperialPlaceHolderMargin}
          />
          </View>);

    return (<FormSection>{form}</FormSection>);
  }
  private getPropertiesBasedOnUnitPref = (useImperialUnit: boolean): any => {
    if (useImperialUnit) {
      return {
        minMaxChecks: [maxWeightImperial, minWeightImperial],
        weightPlaceholder: 'lb',
    };
    }
    return {
      minMaxChecks: [maxWeight, minWeight],
      weightPlaceholder: 'kg',
  };
 }
}
const styles = StyleSheet.create({
  imperialContainerWidth: {
    width: '49%',
  },
  imperialPlaceHolderMargin: {
    marginLeft: 5,
  },
});
